module.exports = __webpack_public_path__ + "img/Picture6.d5eae402.jpg";